export const ActivateCoreFlags = {
  Auth0VerificationFlowTracing:
    'squad-activate-core.auth0-verification-flow-tracing',
  MaintenanceMode: 'maintenance-mode',
  StagingPermittedDomains: 'activate.stagingPermittedDomains',
  UseRedirectServiceV1: 'api-platform-squad.use-redirect-service-v1',
  SAMLGraphql: 'squad-api-platform.saml-graphql',
  EnableAuth0SamlAsIdpIntegration:
    'squad-activate-core.enable-auth0-saml-as-idp-integration',
  Auth0AccessToken: 'squad-api-platform.auth0-access-token',
  Auth0ConsolidateAuthTokenStorage:
    'squad-api-platform.consolidate-auth-token-storage',
  Auth0RefreshToken: 'squad-api-platform.auth0-refresh-token',
  FixAuth0UserSessions: 'squad-api-platform.fix-auth0-user-sessions',
  ReservableCapacityValidation:
    'activate-experience-integrations.reservable-capacity-validation',
  DisableWhitelabelOAuthConfig:
    'squad-api-platform.disable-whitelabel-oauthconfig',
  PrismaMigrationRemoveUserIntegrationResolver:
    'pavel.prisma-migration-remove-user-integration-resolver',
  ChannelManagementGoLive: 'foundations.channel-management-go-live',
  MultifamilyCreateProperty: 'multifamily.create-property',
  IntuitiveUserManagement: 'multifamily.intuitive-user-management',
  AddManualResidents: 'multifamily.add-manual-residents',
  MessagingAndMarketplace: 'multifamily.messaging-and-marketplace',
  MediaUploadV2: 'multifamily.media-upload-v2',
  UrgentCommunicationMessage: 'multifamily.urgent-communications-message',
  RelayUI: 'squad-relay-and-beacon.relay-UI',
  PushNotificationPermissionModal:
    'squad-activate-core.show-push-notification-permission-modal',
  PrismaMigrationRequestPhoneNumberVerificationResolver:
    'pavel.prisma-migration-request-phone-number-verification-resolver',
  PrismaMigrationVerifyEmailOnBehalfOfUserResolver:
    'pavel.prisma-migration-verify-email-on-behalf-of-user-resolver',
  PrismaMigrationRequestAccountDeletionResolver:
    'pavel.prisma-migration-request-account-deletion-resolver',
  CoreTouchContentLightweightResponse:
    'squad-core.touch-content.lightweight-response',
  NotificationsPerformanceUsersMultiQuery:
    'activate-core.notifications-performance.users-multi-query',
  EnableOAuthAuth0UserDetection:
    'squad-activate-core.enable-oauth-auth0-user-detection',
  UseOIDCConnectionParameter:
    'squad-activate-core.use-oidc-connection-parameter',
  MobileClearSessionWhenExpiredRedirect:
    'squad-activate-core.mobile-clear-session-when-expired-redirect',
  PhoneInputCountryCodeChangeFix:
    'squad-activate-core.phone-input-country-code-change-fix',
  SectionContentListBgFix:
    'squad-activate-core.section-content-list-bg-fix',
  ContentItemsAlignmentFixMobile:
    'squad-activate-core.content-items-alignment-fix-mobile',
  WhitelabelOutlineButtonBackgroundFix:
    'squad-activate-core.whitelabel-outline-button-background-fix',
  MixpanelEnabled: 'squad-activate-core.mixpanel-enabled',
  ContentNotificationReducedBatchSize:
    'squad-activate-core.content-notification-reduced-batch-size',
  OldUnscheduledNotificationGuard:
    'squad-activate-core.old-unscheduled-notification-guard',
  GetUsersByChannelIdTransactionFix:
    'activate-core.user-management.get-users-by-channel-id-transaction-fix',
  GetUsersByChannelIdOptimisation:
    'squad-activate-core.user-management.get-users-by-channel-id-optimisation',
  UpdateUserLastSeenThrottle:
    'squad-activate-core.user-management.update-user-last-seen-throttle',
  ReturnFirstChannelIfDefaultChannelIsNull:
    'squad-activate-core.return-first-channel-if-default-channel-is-null',
  GroupRoleAudienceChannelFieldResolver:
    'squad-activate-core.group-role.audience-channel-field-resolver',
  DropdownItemSelectionFix:
    'squad-activate-core.dropdown-item-selection-fix',
  Auth0ForcePromptLogin:
    'squad-activate-core.authentication.auth0_force_prompt_login',
  UserLoggingRedirectAuth0Fix:
    'squad-activate-core.user-logging-redirect-auth0-fix',
  PushNotificationUseChannelDisplayName:
    'squad-activate-core.push-notification-use-channel-display-name',
  WorkflowStatusChangeConditionalRulesFix:
    'squad-activate-core.workflow-status-change-conditional-rules-fix',
  BackButtonNotVisibleFilterContent:
    'squad-activate-core.back-button-not-visible-filter-content',
  Auth0TranslationFix: 'squad-activate-core.auth0-translation-fix',
  MapsModuleFixes: 'squad-activate-core.maps-module-fixes',
  PostResetTimeNotTriggeringFix:
    'squad-activate-core.post-reset-time-not-triggering-fix',
  FixExpireContentLoad:
    'squad-activate-core.fix-expire-content-load',
  ReservableTeamRulesFix: 'squad-activate-core.reservable-team-rules-fix',
  QuotaRedemptionExceedsFix:
    'squad-activate-core.quota-redemption-exceeds-fix',

  // Rogue flags
  ActivatePlatformCoreActivateRebrand:
    'activate-platform-core.activate-rebrand',
  ActivatePlatformCoreHidePendoWidget:
    'activate-platform-core.hide-pendo-widget',
  ActivatePlatformCoreHideZendeskWidget:
    'activate-platform-core.hide-zendesk-widget',
  ActivatePlatformCoreKoaCompression: 'activate-platform-core.koa-compression',
  ActivatePlatformCoreShowWhitelabelNameInSms:
    'activate-platform-core.show-whitelabel-name-in-sms',
  ApiPlatformDisableStudioCustomOnboarding:
    'api-platform.disable-studio-custom-onboarding',
  OtherIntegrationsOneWaySyncCalendarIntegrationTest:
    'other-integrations.one-way-sync-calendar-integration-test',
  OtherIntegrationsRiseActivateViabilityPoc:
    'other-integrations.rise-activate-viability-poc',
  SquadApiPlatformActivateTokenManager:
    'squad-api-platform.activate-token-manager',
  SquadApiPlatformAuth0EnableOidcWebviewScene:
    'squad-api-platform.auth0-enable-oidc-webview-scene',
  SquadApiPlatformAuth0RedirectIos184:
    'squad-api-platform.auth0-redirect-ios-18-4',
  SquadApiPlatformAuthenticateMiddlewareLib:
    'squad-api-platform.authenticate-middleware-lib',
  SquadApiPlatformOidcV2: 'squad-api-platform.oidc-v2',
  SquadApiPlatformRequirePresenceOfAcmSession:
    'squad-api-platform.require-presence-of-acm-session',
  UsersServiceUseNewUserService: 'users-service.use-new-user-service',
  CoreApiPlatformActivateSessionExpire:
    'core-api-platform.activate-session-expire',
  CoreApiClearSessionCallback: 'core-api.clear-session-callback',
  MultifamilyParcelManagement: 'multifamily.parcel-management',
  MultifamilyResidentDetails: 'multifamily.resident-details',
  MultifamilyUnitFloors: 'multifamily.unit-floors',
  FastContentQuery:
    'activate-core-experience-content-query-optimization-resolver',
  ChannelForAdminQuery: 'activate-core.channel-for-admin-query',
  // Rogue flags end
} as const;
